module.exports = __webpack_public_path__ + "img/yszc-icon.bc53c42a.png";